<template>
    <oss-dialog v-model="dialog" title="Importer" min-width="60vw">
        <!-- <v-card>
        <v-card-title style="padding: 0px">
            <v-toolbar  color="primary">
                <v-toolbar-title>Importer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close(undefined)">
                    <v-icon>$close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card-title> -->

        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="4">
                <v-text-field
                    v-model="sire"
                    :placeholder="sirenMode ? 'N&#xb0;SIREN' : 'N&#xb0;SIRET'"
                    outlined
                    :rules="[
                        (siren) =>
                            (!!sire && !!this.sire.match(/^[0-9]{9}$/)) ||
                            (!!this.sire && !!this.sire.match(/^[0-9]{14}$/)) ||
                            'Mauvais format',
                    ]"
                    density="compact"
                >
                </v-text-field>
            </v-col>
            <v-col cols="8">
                <v-data-table-server
                    :headers="headers"
                    :items="items"
                    v-model:page="pagination.page"
                    v-model:sort-by="pagination.sortBy"
                    v-model:items-per-page="pagination.rowsPerPage"
                    :items-length="companiesCount"
                    :items-per-page-options="[5, 10, 25]"
                    :loading="loading"
                    class="table"
                    loading-text="Recherche de votre société en cours ..."
                >
                    <template v-slot:no-data>
                        <div class="text-center" style="max-height: 70vh" v-if="sire !== ''">
                            Aucune Société n'a été trouvé avec ce
                            {{ sirenMode ? "SIREN" : "SIRET" }}
                        </div>
                        <div class="text-center" style="max-height: 70vh" v-else>
                            Entrez votre numero de {{ sirenMode ? "Siren" : "Siret" }}
                        </div>
                    </template>
                    <template v-slot:item="props">
                        <tr @click="close(props.item)">
                            <td>
                                {{ props.item.name }}
                            </td>
                            <td>
                                {{ props.item.siret }}
                            </td>
                            <td>
                                {{ props.item.address }}
                            </td>
                            <td>
                                <v-btn
                                    elevation="0"
                                    :disabled="props.item.isActive === false"
                                    size="small"
                                >
                                    Choisir
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table-server>
            </v-col>
        </v-row>
    </oss-dialog>
</template>

<script lang="ts">
import COMPANIES_API from "../graphql/company/CompaniesDBAndAPI.gql";

import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component({
    emits: ["close"],
})
export class SirenCompanyDialog extends Vue {
    @Model() value: boolean;
    @Prop({ default: "" }) sireInput;
    @Prop({ default: false }) sirenMode;

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    sire_: string = "";

    headers: Array<any> = [
        {
            title: "Company",
            value: "name",
        },
        {
            title: "Siret",
            value: "siret",
        },
        {
            title: "Adresse",
            value: "address",
        },
        {
            title: "",
            value: "",
        },
    ];

    pagination: any = {
        page: 1,
        rowsPerPage: 5,
        sortBy: [{ key: "name" }],
    };

    companiesCount: number = 0;

    get loading() {
        if (this.sire === "") return false;
        if (this.$apollo.queries.items) {
            return this.$apollo.queries.items.loading;
        }
        return false;
    }

    get sire() {
        if (this.sireInput && !this.sire_) {
            this.sire_ = this.sireInput;
        }
        return this.sire_;
    }

    set sire(data) {
        this.sire_ = data;
    }

    @Apollo({
        query: COMPANIES_API,
        variables() {
            return {
                search: this.sire,
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            };
        },
        debounce: 500,
        skip() {
            // 44357217700014
            return (
                (!this.sire && !this.sire.match(/^[0-9]{9}$/)) ||
                (!this.sire && !this.sire.match(/^[0-9]{14}$/))
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data && data.companiesDBAndAPI) {
                    console.log(data);
                    if (data.companiesDBAndAPI.companies) {
                        this.next = true;
                        this.items = data.companiesDBAndAPI.companies;

                        if (data.companiesDBAndAPI.companies.length < this.pagination.rowsPerPage) {
                            if (this.companiesCount) {
                                this.companiesCount -= 1;
                            }
                        } else if (this.companiesCount === 0) {
                            this.companiesCount = 1;
                        }
                        this.companiesCount += data.companiesDBAndAPI.companies.length;
                    } else {
                        this.items = [];
                    }
                }
            }
        },
    })
    items: Array<any> = [];

    close(item) {
        this.$emit("close", item);
        this.dialog = false;
    }
}

export default toNative(SirenCompanyDialog);
</script>
